<!-- översätt: Hela sidan -->
<app-form-section>
    <app-form-row>
        <app-form-group>
            <div class="title-row">
                <div class="left">
                    <span class="material-symbols-rounded" aria-label="My account"> account_circle </span>
                    <div class="title">
                        <h1>{{ f.firstName.value }} {{ f.lastName.value }}</h1>
                        <h4>{{ 'MENU.USER' | translate }}</h4>
                    </div>
                </div>
                <div class="actionbuttons">
                    <button (click)="logout()">{{ 'GENERAL.LOGOUT' | translate }}</button>
                </div>
            </div>
        </app-form-group>
    </app-form-row>

    <app-form-row>
        <app-form-group>
            <div class="box">
                <app-form-section>
                    <app-form-row-header [title]="'FEATURES.USER.CONTACT_INFORMATION' | translate" icon="person" />
                    <!-- PREVIEWLÄGE -->
                    <div class="form" [hidden]="editMode">
                        <p>{{ f.firstName.value }} {{ f.lastName.value }}</p>
                        <p>{{ f.phone.value }}</p>
                        <p>{{ f.email.value }}</p>
                        <p>{{ customerName$ | async }}</p>
                        <br />
                        <app-form-row>
                            <app-form-group>
                                <button (click)="enterEditMode()" [ngClass]="{ hidden: editMode }">
                                    {{ 'BUTTONS.EDIT' | translate }}
                                </button>
                            </app-form-group>
                        </app-form-row>
                    </div>

                    <!-- EDITERINGSLÄGE! -->
                    <div class="form" [hidden]="!editMode">
                        <form [formGroup]="userForm" autocomplete="off">
                            <app-form-row>
                                <app-form-group>
                                    <label for="title">{{ 'FEATURES.USER.TITLE' | translate }}</label>
                                    <input
                                        appInputValidator
                                        [checkValidity]="showPotentialValidationMessages"
                                        id="title"
                                        formControlName="title"
                                        type="text"
                                        [placeholder]=""
                                    />
                                </app-form-group>
                            </app-form-row>
                            <app-form-row>
                                <app-form-group>
                                    <label for="firstName">{{ 'FEATURES.USER.FIRST_NAME' | translate }}</label>
                                    <input
                                        appInputValidator
                                        [checkValidity]="showPotentialValidationMessages"
                                        id="firstName"
                                        formControlName="firstName"
                                        type="text"
                                        [placeholder]=""
                                    />
                                    <app-validation-message
                                        *ngIf="showPotentialValidationMessages && editMode"
                                        [control]="f.firstName"
                                        languageKey="FEATURES.USER.FIRST_NAME"
                                    />
                                </app-form-group>
                            </app-form-row>

                            <app-form-row>
                                <app-form-group>
                                    <label for="lastName">{{ 'FEATURES.USER.LAST_NAME' | translate }}</label>
                                    <input
                                        appInputValidator
                                        [checkValidity]="showPotentialValidationMessages"
                                        id="lastName"
                                        formControlName="lastName"
                                        type="text"
                                        [placeholder]=""
                                    />
                                    <app-validation-message
                                        *ngIf="showPotentialValidationMessages && editMode"
                                        [control]="f.lastName"
                                        languageKey="FEATURES.USER.LAST_NAME"
                                    />
                                </app-form-group>
                            </app-form-row>
                            <app-form-row>
                                <app-form-group>
                                    <label for="email">{{ 'FEATURES.USER.EMAIL' | translate }}</label>
                                    <input
                                        appInputValidator
                                        [checkValidity]="showPotentialValidationMessages"
                                        id="email"
                                        formControlName="email"
                                        type="email"
                                        [placeholder]=""
                                    />
                                    <app-validation-message
                                        *ngIf="showPotentialValidationMessages && editMode"
                                        [control]="f.email"
                                        languageKey="FEATURES.USER.EMAIL"
                                    />
                                </app-form-group>
                            </app-form-row>
                            <app-form-row>
                                <app-form-group>
                                    <label for="phone">{{ 'FEATURES.USER.PHONE' | translate }}</label>
                                    <input
                                        appInputValidator
                                        [checkValidity]="showPotentialValidationMessages"
                                        id="phone"
                                        formControlName="phone"
                                        type="text"
                                        [placeholder]=""
                                    />
                                </app-form-group>
                            </app-form-row>
                            <app-form-row>
                                <app-form-group>
                                    <label for="customerId">{{ 'FEATURES.USER.CUSTOMER' | translate }}</label>
                                    <app-dropdown
                                        [items]="customers$ | async"
                                        formControlName="customerId"
                                        tabindex="0"
                                        role="combobox"
                                        aria-haspopup="listbox"
                                    />
                                </app-form-group>
                            </app-form-row>
                            <app-form-row>
                                <app-form-group>
                                    <button (click)="cancelEditMode()" [ngClass]="{ hidden: editMode }">
                                        {{ 'BUTTONS.CANCEL' | translate }}
                                    </button>
                                </app-form-group>
                                <app-form-group>
                                    <button (click)="saveUser()" class="primary" [disabled]="userForm.invalid">
                                        {{ 'BUTTONS.SAVE' | translate }}
                                    </button>
                                </app-form-group>
                            </app-form-row>
                        </form>
                    </div>
                </app-form-section>
            </div>

            <div class="box">
                <app-form-section>
                    <!-- Title: Lösenord -->
                    <app-form-row-header [title]="'FEATURES.USER.PASSWORD' | translate" icon="key" />
                    <!-- PREVIEWLÄGE -->
                    <div class="form" [hidden]="editPassword">
                        <p>**********</p>
                        <br />
                        <app-form-row>
                            <app-form-group>
                                <button (click)="enterEditPassword()" [ngClass]="{ hidden: editPassword }">
                                    {{ 'BUTTONS.EDIT' | translate }}
                                </button>
                            </app-form-group>
                        </app-form-row>
                    </div>

                    <!-- EDITERINGSLÄGE -->
                    <div class="form" [hidden]="!editPassword">
                        <form [formGroup]="userForm" autocomplete="off">
                            <app-form-row>
                                <app-form-group>
                                    <label for="password">{{ 'FEATURES.USER.PASSWORD' | translate }}</label>
                                    <input
                                        appInputValidator
                                        [checkValidity]="showPotentialValidationMessages"
                                        id="password"
                                        formControlName="password"
                                        type="password"
                                        [placeholder]=""
                                        autocomplete="new-password"
                                    />
                                    <app-validation-message
                                        *ngIf="showPotentialValidationMessages && editPassword"
                                        [control]="f.password"
                                        languageKey="FEATURES.USER.PASSWORD"
                                    />
                                </app-form-group>
                            </app-form-row>

                            <app-form-row>
                                <app-form-group>
                                    <label for="confirmPassword">{{
                                        'FEATURES.USER.CONFIRM_PASSWORD' | translate
                                    }}</label>
                                    <input
                                        appInputValidator
                                        [checkValidity]="showPotentialValidationMessages"
                                        id="confirmPassword"
                                        formControlName="confirmPassword"
                                        type="password"
                                        [placeholder]=""
                                        autocomplete="new-password"
                                    />
                                    <app-validation-message
                                        *ngIf="showPotentialValidationMessages && editPassword"
                                        [control]="f.confirmPassword"
                                        languageKey="FEATURES.USER.CONFIRM_PASSWORD"
                                    />
                                </app-form-group>
                            </app-form-row>
                            <app-form-row>
                                <app-form-group>
                                    <button (click)="cancelEditPassword()" [ngClass]="{ hidden: editPassword }">
                                        {{ 'BUTTONS.CANCEL' | translate }}
                                    </button>
                                </app-form-group>
                                <app-form-group>
                                    <button (click)="saveUser()" class="primary" [disabled]="userForm.invalid">
                                        {{ 'BUTTONS.SAVE' | translate }}
                                    </button>
                                </app-form-group>
                            </app-form-row>
                        </form>
                    </div>
                </app-form-section>
            </div>
        </app-form-group>

        <app-form-group class="disabled">
            <div class="box">
                <app-form-section>
                    <!-- Title: Mörkt läge -->
                    <app-form-row-header [title]="'Darkmode'" icon="dark_mode" />
                    <div class="form">
                        <app-form-row class="toggle-row">
                            <label for="darkMode">Darkmode</label>
                            <label class="switch">
                                <input type="checkbox" id="darkMode" />
                                <span class="slider"></span>
                            </label>
                        </app-form-row>
                    </div>
                    <!-- Title: notiser -->
                    <app-form-row-header [title]="'Notiser'" icon="notifications" />
                    <div class="form">
                        <app-form-row class="toggle-row">
                            <label for="addedReader">Tillagd som läsare</label>
                            <label class="switch">
                                <input type="checkbox" id="addedReader" />
                                <span class="slider"></span>
                            </label>
                        </app-form-row>
                        <app-form-row class="toggle-row">
                            <label for="addedAdmin">Tillagd som ansvarig</label>
                            <label class="switch">
                                <input type="checkbox" id="addedAdmin" />
                                <span class="slider"></span>
                            </label>
                        </app-form-row>
                        <app-form-row class="toggle-row">
                            <label for="reminder">Påminnelser</label>
                            <label class="switch">
                                <input type="checkbox" id="reminder" />
                                <span class="slider"></span>
                            </label>
                        </app-form-row>
                        <app-form-row class="toggle-row">
                            <label for="newEmail">Nytt mail</label>
                            <label class="switch">
                                <input type="checkbox" id="newEmail" />
                                <span class="slider"></span>
                            </label>
                        </app-form-row>
                    </div>
                    <app-form-row-header [title]="'Rapporter'" icon="assignment" />
                    <div class="form">
                        <app-form-row class="toggle-row">
                            <label for="weeklyReport">Veckorapport</label>
                            <label class="switch">
                                <input type="checkbox" id="weeklyReport" />
                                <span class="slider"></span>
                            </label>
                            <span class="disclaimer">
                                Veckorapporten visar avtalens status, nya och förfallande avtal, ändringar, risker samt
                                åtgärder och kommande deadlines
                            </span>
                        </app-form-row>
                    </div>
                </app-form-section>
            </div>
        </app-form-group>

        <app-form-group>
            <div class="box">
                <app-form-section>
                    <app-form-row-header [title]="'FEATURES.USER.OVERVIEW' | translate" icon="assignment" />
                    <div class="form text">
                        <p>
                            {{
                                'FEATURES.USER.SUBSCRIPTION_NUM_OF_RESPONSIBLE_AGREEMENTS'
                                    | translate: { numOfResponsibleAgreements: userProfile.numOfResponsibleAgreements }
                            }}
                        </p>
                        <p>
                            {{
                                'FEATURES.USER.SUBSCRIPTION_NUM_OF_READER_AGREEMENTS'
                                    | translate: { numOfReaderAgreements: userProfile.numOfReaderAgreements }
                            }}
                        </p>
                        <p>
                            {{
                                'FEATURES.USER.SUBSCRIPTION_NUM_OF_USED_CREDITS'
                                    | translate
                                        : {
                                              numOfUsedCredits: userProfile.numOfUsedCredits,
                                              numOfCredits: fs.numOfCredits.value
                                          }
                            }}
                        </p>
                    </div>
                </app-form-section>
            </div>
            <div class="box">
                <app-form-section>
                    <app-form-row-header [title]="'FEATURES.USER.INCOMING_EMAIL' | translate" icon="inbox" />
                    <div class="form">
                        <app-form-row> {{ f.inboxEmail.value }} </app-form-row>
                    </div>
                </app-form-section>
            </div>
            <div class="box">
                <app-form-section>
                    <app-form-row-header [title]="'Abonnemang'" icon="subscriptions" />
                    <!-- PREVIEWLÄGE -->
                    <div class="form" [hidden]="editSubscriptionMode">
                        <p>{{ 'FEATURES.USER.SUBSCRIPTION_USER' | translate }}: {{ fs.numOfUsers.value }}</p>
                        <p>{{ 'FEATURES.USER.SUBSCRIPTION_READER' | translate }}: {{ fs.numOfReaders.value }}</p>
                        <p>
                            {{ 'FEATURES.USER.SUBSCRIPTION_AI' | translate }}:
                            {{ fs.ai.value ? ('BUTTONS.YES' | translate) : ('BUTTONS.NO' | translate) }}
                        </p>
                        <p>
                            {{ 'FEATURES.USER.SUBSCRIPTION_RISK_ANALYSIS' | translate }}:
                            {{ fs.riskAnalysis.value ? ('BUTTONS.YES' | translate) : ('BUTTONS.NO' | translate) }}
                        </p>
                        <p>{{ 'FEATURES.USER.SUBSCRIPTION_VALID_TO' | translate }}</p>
                        <!-- <p>
                            {{ 'FEATURES.USER.SUBSCRIPTION_NEXT_INVOICE_DATE' | translate }}:
                            {{ getNextInvoiceDate(fs.invoiceIntervalId.value) }}
                        </p> -->
                        <p>
                            {{
                                'FEATURES.USER.SUBSCRIPTION_COST_PER_MONTH'
                                    | translate: { calculatedSubscriptionCost: calculatedSubscriptionCost }
                            }}
                        </p>
                        <br />
                        <app-form-row [hidden]="editSubscriptionMode">
                            <app-form-group>
                                <button
                                    (click)="enterEditSubscriptionMode()"
                                    [ngClass]="{ hidden: editSubscriptionMode }"
                                >
                                    {{ 'BUTTONS.EDIT' | translate }}
                                </button>
                            </app-form-group>
                        </app-form-row>
                    </div>

                    <!-- EDITERINGSLÄGE! -->
                    <div class="form" [hidden]="!editSubscriptionMode">
                        <form [formGroup]="subscriptionForm" autocomplete="off">
                            <app-form-row>
                                <app-form-group>
                                    <app-checkbox
                                        formControlName="ai"
                                        [text]="'FEATURES.USER.SUBSCRIPTION_AI' | translate"
                                    />
                                </app-form-group>
                            </app-form-row>
                            <app-form-row>
                                <app-form-group>
                                    <app-checkbox
                                        formControlName="riskAnalysis"
                                        [text]="'FEATURES.USER.SUBSCRIPTION_RISK_ANALYSIS' | translate"
                                    />
                                </app-form-group>
                            </app-form-row>
                            <app-form-row>
                                <app-form-group>
                                    <label for="numOfUsers">{{ 'FEATURES.USER.NUM_OF_USERS' | translate }}</label>
                                    <input
                                        appInputValidator
                                        [checkValidity]="showPotentialValidationMessages"
                                        id="numOfUsers"
                                        formControlName="numOfUsers"
                                        type="number"
                                        min="1"
                                        [placeholder]=""
                                    />
                                    <app-validation-message
                                        *ngIf="showPotentialValidationMessages && editSubscriptionMode"
                                        [control]="fs.numOfUsers"
                                        languageKey="FEATURES.USER.NUM_OF_USERS"
                                    />
                                </app-form-group>
                            </app-form-row>
                            <app-form-row>
                                <app-form-group>
                                    <label for="numOfReaders">{{
                                        'FEATURES.USER.SUBSCRIPTION_INVOICE_INTERVAL' | translate
                                    }}</label>
                                    <app-dropdown
                                        [items]="invoiceIntervalsOptions"
                                        formControlName="invoiceIntervalId"
                                    />
                                </app-form-group>
                            </app-form-row>
                            <app-form-row>
                                <app-form-group>
                                    <p>
                                        {{
                                            'FEATURES.USER.SUBSCRIPTION_COST_PER_MONTH'
                                                | translate: { calculatedSubscriptionCost: calculatedSubscriptionCost }
                                        }}
                                    </p>
                                </app-form-group>
                            </app-form-row>
                            <app-form-row>
                                <app-form-group>
                                    <app-checkbox
                                        formControlName="cancelled"
                                        [text]="'FEATURES.USER.SUBSCRIPTION_CANCEL' | translate"
                                    />
                                </app-form-group>
                            </app-form-row>
                            <app-form-row>
                                <app-form-group>
                                    <button
                                        (click)="cancelEditSubscriptionMode()"
                                        [ngClass]="{ hidden: editSubscriptionMode }"
                                    >
                                        {{ 'BUTTONS.CANCEL' | translate }}
                                    </button>
                                </app-form-group>
                                <app-form-group>
                                    <button (click)="saveSubscription()" class="primary" [disabled]="userForm.invalid">
                                        {{ 'BUTTONS.SAVE' | translate }}
                                    </button>
                                </app-form-group>
                            </app-form-row>
                        </form>
                    </div>
                </app-form-section>
            </div>
        </app-form-group>
    </app-form-row>
</app-form-section>
